import { MainService } from './main.service'

export const services = (gaApp) => ({
  main: new MainService(gaApp),
})
